<template>
  <div :class="scope.clsPrefix">
    <div class="detail-container">
      <div class="detail-header">
        <div class="header-title">{{ detailData.title }}</div>
        <div class="header-subtitle">提交人：{{ detailData.requesterAgentName || detailData.requester }}</div>
      </div>
      <div class="desc-card">
        <div class="desc-text">{{ detailData.description }}</div>
      </div>
      <div class="info-cards">
        <div class="info-card">
          <div class="info-label">提交人</div>
          <div class="info-value">{{ detailData.requesterAgentName || detailData.requester }}</div>
        </div>
        <div class="info-card">
          <div class="info-label">提交时间</div>
          <div class="info-value">{{ formatDate(detailData.createTime) }}</div>
        </div>
        <div class="info-card">
          <div class="info-label">状态</div>
          <div class="info-value status-tag" :class="getStatusClass(detailData.status)">{{ getStatusText(detailData.status) }}</div>
        </div>
      </div>
      <div class="section">
        <div class="section-title">重点结论</div>
        <div class="conclusion-list">
          <div v-for="(item, index) in detailData.items" :key="index" class="conclusion-item">
            <span class="conclusion-dot"></span>
            <span class="conclusion-text">{{ item.item }}</span>
          </div>
        </div>
      </div>
      <div class="action-buttons" v-if="detailData.status === 'PENDING'">
        <div class="btn-reject" @click="handleReject">驳回</div>
        <div class="btn-approve" @click="handleApprove">通过</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getDecisionDetailApi, reviewDecisionApi } from '@/api/agentAuth'
export default {
  name: 'DecisionDetail',
  props: {
    id: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      scope: {
        clsPrefix: 'rvc-cosmoplat-workspace-decision-detail'
      },
      detailData: {}
    }
  },
  created() {
    this.fetchDecisionDetail()
  },
  watch: {
    id(newId) {
      if (newId) this.fetchDecisionDetail()
    }
  },
  methods: {
    async fetchDecisionDetail() {
      if (!this.id) {
        this.detailData = {}
        return
      }
      try {
        const res = await getDecisionDetailApi(this.id)
        if (res && res.data) {
          this.detailData = { ...res.data }
        } else {
          this.detailData = {}
        }
      } catch (error) {
        console.error('获取待决策事项详情失败:', error)
        this.detailData = {}
      }
    },
    getStatusText(status) {
      const map = { PENDING: '待决策', APPROVED: '已批准', REJECTED: '已拒绝', PARTIAL: '部分批准' }
      return map[status] || '待决策'
    },
    getStatusClass(status) {
      const map = { PENDING: 'status-pending', APPROVED: 'status-approved', REJECTED: 'status-rejected', PARTIAL: 'status-partial' }
      return map[status] || 'status-pending'
    },
    formatDate(date) {
      if (!date) return '-'
      const d = new Date(date)
      if (isNaN(d.getTime())) return date
      const pad = n => String(n).padStart(2, '0')
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
    },
    async handleReject() {
      try {
        // await reviewDecisionApi(this.id, { items: { result: 'REJECTED' }})
        await reviewDecisionApi(this.id, {
          status: 'REJECTED',
          items: this.detailData.items
        })
        this.$message.success('已驳回')
        this.fetchDecisionDetail()
      } catch (error) {
        console.error('驳回失败:', error)
      }
    },
    async handleApprove() {
      try {
        // await reviewDecisionApi(this.id, { items: { result: 'APPROVED' }})
        await reviewDecisionApi(this.id, {
          status: 'APPROVED',
          items: this.detailData.items
        })
        this.$message.success('已通过')
        this.fetchDecisionDetail()
      } catch (error) {
        console.error('审批通过失败:', error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$class-prefix: "rvc-cosmoplat-workspace-decision-detail";
.#{$class-prefix} {
  height: 100%;
  padding: 24px;
  background: #fff;
  border-radius: 8px;
  // min-height: 500px;
  // height: 100%;
  position: relative;
  // overflow-y: auto;
}
.detail-container {
  // position: relative;
}
.detail-header {
  margin-bottom: 16px;
}
.header-title {
  font-size: 24px;
  font-weight: 700;
  color: #333;
  margin-bottom: 6px;
  font-family: PingFangSC-Bold;
}
.header-subtitle {
  font-size: 14px;
  color: #000;
  font-family: PingFangSC-Regular;
  margin-bottom: 39px;
}
.desc-card {
  // padding: 14px 16px;
  // background: #FAFBFC;
  // border-radius: 8px;
  margin-bottom: 12px;
}
.desc-text {
  font-size: 14px;
  color: #4A5FF3;
  font-family: PingFangSC-Regular;
}
.info-cards {
  display: flex;
  gap: 12px;
  margin-bottom: 24px;
}
.info-card {
  flex: 1;
  padding: 15px 22px;
  border: 1px solid #EDF1FB;
  border-radius: 8px;
}
.info-label {
  font-size: 12px;
  color: #666;
  margin-bottom: 11px;
  font-family: PingFangSC-Regular;
}
.info-value {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  line-height: 32px;
  font-family: PingFangSC-Medium;
  &.status-tag {
    font-weight: 600;
    font-size: 16px;
    line-height: 32px;
  }
  &.status-pending {
    // background: #FFF8E1;
    color: #FF9800;
  }
  &.status-approved {
    // background: #E8F5E9;
    color: #4CAF50;
  }
  &.status-rejected {
    // background: #FFEBEE;
    color: #F44336;
  }
  &.status-partial {
    // background: #FFF8E1;
    color: #FF9800;
  }
}
.section {
  margin-bottom: 24px;
}
.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 16px;
  font-family: PingFangSC-Medium;
}
.conclusion-list {
  border: 1px solid #EDF1FB;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
}
.conclusion-item {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  // padding: 12px 16px;
  // background: #FAFBFC;
  // border-radius: 8px;
}
.conclusion-dot {
  width: 6px;
  height: 6px;
  background: #4A5FF3;
  border-radius: 50%;
  margin-top: 6px;
  flex-shrink: 0;
}
.conclusion-text {
  font-size: 14px;
  color: #333;
  // line-height: 1.6;
  font-family: PingFangSC-Regular;
}
.action-buttons {
  // position: absolute;
  // bottom: 28px;
  // right: 30px;
  display: flex;
  justify-content: flex-end;
  margin-top: 100px;
  gap: 12px;
}
.btn-reject {
  width: 96px;
  height: 40px;
  border: 1px solid #4A5FF3;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 16px;
  color: #4A5FF3;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 14px;
  background: white;
  font-family: PingFangSC-Regular;
  transition: all 0.2s;
  // &:hover {
  //   border-color: #BFBFBF;
  //   background: #FAFAFA;
  // }
}
.btn-approve {
  width: 96px;
  height: 40px;
  background-image: linear-gradient(270deg, #4A5FF3 0%, #4E86FF 100%);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 16px;
  color: #FFFFFF;
  letter-spacing: 0;
  line-height: 14px;
  cursor: pointer;
  font-family: PingFangSC-Regular;
  transition: all 0.2s;
  // &:hover {
  //   background: #3B4FE8;
  // }
}
</style>
